import { Component, OnInit, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-product-item-person',
  templateUrl: './product-item-person.component.html',
  styleUrls: ['./product-item-person.component.css']
})
export class ProductItemPersonComponent implements OnInit {

  @Input()
  product:any;

  public urlHost = "";
  constructor() {
    this.urlHost = environment.urlHostImage;
   }

  ngOnInit() {
  }

}
